module.exports = __webpack_public_path__ + "img/picking-process.4d65e77d.svg";